import React, { useState, useEffect } from 'react';
import './../entrydoor.css';

const Notes = ({ value, onChange, label = 'Notes' , disabled = false }) => {
    const [selectedNotes, setSelectedNotes] = useState(value || "");

    useEffect(() => {
        setSelectedNotes(value || null);
    }, [value]);

    const handleNotesChange = (e) => {
        setSelectedNotes(e.target.value);
        onChange(e.target.value)
    };

    return (
        <div className="a-container a-containerw">
            <label disabled={disabled} htmlFor="Notes">{label}</label>
            <textarea
                disabled={disabled}
                id="Notes"
                value={selectedNotes}
                onChange={handleNotesChange}
                wrap="soft" // or "hard"
                style={{
                  width: '100%',
                  whiteSpace: 'pre-wrap', // ensures text wraps
                  wordWrap: 'break-word', // breaks long words
                  fontFamily: 'monospace', // optional for better char alignment
                  lineHeight: '1.4em'
                }}
            >
            </textarea>
        </div>
    );
};

export default Notes;
